import Buzzfeed from 'marketing-website/components/icons/Buzzfeed';
import Cabify from 'marketing-website/components/icons/Cabify';
import DeliverooWord from 'marketing-website/components/icons/DeliverooWord';
import Monzo from 'marketing-website/components/icons/Monzo';
import Yieldr from 'marketing-website/components/icons/Yieldr';
import Hudl from 'marketing-website/components/icons/Hudl';

const caseStudyLogos = [
  {
    id: 2,
    logo: Cabify,
  },
  {
    id: 0,
    logo: Buzzfeed,
  },
  {
    id: 3,
    logo: Yieldr,
  },
  {
    id: 1,
    logo: Monzo,
  },
  {
    id: 4,
    logo: Hudl,
  },
  {
    id: 5,
    logo: DeliverooWord,
  },
];

export default caseStudyLogos;



// WEBPACK FOOTER //
// ./src/configs/pages/homepage/caseStudyLogos.js